var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 131,
    viewBox: "0 0 132 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 131
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0515,
    cy: 65.4514,
    rx: 65.4514,
    ry: 65.4514,
    fill: "#00AF91"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0515,
    cy: 65.4514,
    rx: 65.4514,
    ry: 65.4514,
    fill: "#00AF91"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.828 103.832C112.846 94.613 105.668 95.0353 95.5337 99.4689C83.4292 104.817 78.8548 119.315 85.2589 130.504C90.6074 139.864 99.1228 155.628 106.09 168.929L140.925 154.502C134.732 135.923 125.795 114.529 118.828 103.832Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4826 47.6028C44.3009 44.2952 42.2601 40.7061 42.2601 36.7651C42.2601 32.7537 44.3009 29.0942 45.9196 25.4348C47.5382 21.7753 48.8753 17.5528 47.3974 13.8229C49.4383 14.5971 51.268 16.1453 52.2533 18.1158C56.9684 13.8229 60.4167 8.12259 62.1057 2C67.595 5.09648 72.0286 10.0931 74.3509 15.8638C76.251 14.2452 77.5882 11.9228 78.0104 9.45971C80.192 13.6822 82.3736 17.9047 84.5552 22.1975C84.9071 22.9013 86.2442 23.5346 86.3146 22.6901C87.7221 26.7015 88.074 31.5574 86.5257 35.4983C83.6404 27.8979 73.5064 23.1828 65.8356 26.0681C64.0058 26.7719 62.2465 27.8275 61.0501 29.3757C59.713 31.0647 59.15 33.1056 58.2351 35.0057C57.1795 37.1873 55.7016 39.2282 54.9979 41.5506C54.0126 44.5063 54.4349 47.6731 55.3498 50.6289C55.8424 52.1771 57.9536 54.7106 56.4054 55.8366C53.0274 58.2997 47.5382 49.0806 46.4826 47.6028Z",
    fill: "#1D113E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1919 176.318C23.6812 160.343 -4.60944 135.571 -2.2167 119.173C-0.87958 109.743 27.5518 80.1155 73.6472 78.708C88.3555 78.2858 112.212 92.3607 118.054 103.198C138.251 140.849 109.82 184.622 118.124 232.969C120.798 248.522 125.021 258.375 109.82 268.508C99.0524 275.687 89.9037 280.894 76.3214 279.839C50.8458 277.798 20.0921 290.676 11.7879 268.86C2.28728 243.948 10.3804 199.189 18.1919 176.318Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1817 104H96.0456V116.454H92.1817V104Z",
    fill: "#EF5261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8873 108.295H100.341V112.159H87.8873V108.295Z",
    fill: "#EF5261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6085 28.7424C49.3679 22.9013 56.4054 20.0863 62.8798 18.6084C66.9615 17.6935 67.9468 18.2565 72.0989 18.8899C76.251 19.5233 80.6142 20.3678 82.5144 23.8161C84.0626 26.6311 86.8776 29.9387 86.8072 33.0352C86.7368 33.9501 86.7368 34.865 86.3146 35.7095C85.822 36.5539 84.9775 37.2577 84.133 37.8207C80.0512 40.6357 75.0546 42.7469 71.5359 46.2657C68.932 48.9399 66.8912 65.9002 62.3168 65.6891C53.7311 65.2668 45.8492 34.7946 47.6085 28.7424Z",
    fill: "#1D113E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6733 67.8003C77.377 67.3077 78.2215 67.2373 79.066 67.0262C83.1477 65.9002 85.6108 61.6777 86.7368 57.596C89.1296 49.2918 87.7925 39.932 83.2885 32.613C80.6142 28.3201 76.3214 24.3792 71.2544 24.3088C65.2022 24.2384 60.276 29.6573 58.7981 35.428C57.3202 41.2691 58.5166 47.3917 59.6426 53.3031C60.6982 58.722 59.3611 84.6902 64.1466 88.209C78.9253 99.0466 73.0842 70.193 76.6733 67.8003Z",
    fill: "#FA694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3724 49.2919C62.3168 47.6733 60.4167 46.4769 58.4462 46.6177C56.4757 46.6881 54.5756 48.2363 54.3645 50.1364C54.1533 51.8958 55.1386 53.5144 56.0534 54.9923C57.6721 57.5258 59.5722 60.2704 62.4575 61.2556C62.739 61.326 63.0205 61.3964 63.302 61.326C63.6539 61.2556 63.865 60.9741 64.0058 60.6926C65.9059 57.6665 64.5688 53.6552 63.1613 50.3475L63.3724 49.2919Z",
    fill: "#FA694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1238 45.4209C63.7946 36.624 72.7322 30.6422 83.8514 27.2642C79.5586 23.1121 74.0693 20.9305 68.1579 20.4378C65.4133 20.2267 62.5279 20.086 59.9944 21.212C55.7016 23.0417 53.3088 27.8976 53.1681 32.6127C52.9569 37.2574 54.5756 41.0576 56.1238 45.4209Z",
    fill: "#1D113E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.655 111.995C9.32472 109.321 2.70951 107.913 -2.56859 118.399C-7.63557 128.392 -13.8285 146.971 -18.5436 164.706L23.0478 179.273C29.3815 167.239 36.2078 154.36 40.1488 145.564C45.7084 133.037 34.3781 115.232 20.655 111.995Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0024 92.0091C74.3271 92.0091 78.6437 89.457 78.6437 86.3088C78.6437 83.1605 74.3271 80.6084 69.0024 80.6084C63.6776 80.6084 59.361 83.1605 59.361 86.3088C59.361 89.457 63.6776 92.0091 69.0024 92.0091Z",
    fill: "#FA694F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.575,
    height: 632.809,
    fill: "white",
    transform: "translate(-31 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleNurse);
export default __webpack_public_path__ + "static/media/male_nurse.094b5041f7e65c8f85a414643e7b3bcb.svg";
export { ForwardRef as ReactComponent };